//FIXME: Look at this as it can have unintended consequences
// Make sure these get removed when a reset button is clicked.
$('body').on('click', 'input[type=reset]', function () {
  var parentForm = $(this).parents('form');
  if (parentForm.length > 0) {
    parentForm.find('.deleteContainer').remove();
  }
});
